import { ComplexLinqPredicateDTO, LinqPredicateDTO } from './linqPredicate.model';

export class LookupDTO {
  ID: number | string;
  Label: string;
  FullObject: any;
}

/**
 * Modello per la configurazione della lookup, contiene le informazioni
 * sul tipo degli elementi da mostrare e gli eventuali filtri da applicare
 */
export class LookupConfigDTO {
  TypeName: string;
  Filters: Array<LinqPredicateDTO>;
  ComplexFilters: Array<ComplexLinqPredicateDTO>;
  CustomConfig: LookupCustomConfig;
  OptionsFilter: Array<LookupCustomConfig>;
  NamespaceClass: string;
}

export class LookupCustomConfig {
  LabelProperties: Array<string>;
  IncludeFullObject: boolean;
}
